import { TextBadgeColor } from "@bps/fluent-ui";
import {
  OutboundCommStatuses,
  OutboundCommType
} from "@libs/gateways/comms/CommsGateway.dtos.ts";

export const outboundCommStatusesColours = {
  [OutboundCommStatuses.Failed]: TextBadgeColor.red,
  [OutboundCommStatuses.Sent]: TextBadgeColor.green,
  [OutboundCommStatuses.Pending]: TextBadgeColor.yellow,
  [OutboundCommStatuses.Delivered]: TextBadgeColor.green,
  [OutboundCommStatuses.NotSent]: TextBadgeColor.red,
  [OutboundCommStatuses.NoResponse]: TextBadgeColor.red,
  [OutboundCommStatuses.Declined]: TextBadgeColor.red,
  [OutboundCommStatuses.NoLongerRequired]: TextBadgeColor.red
};

export const outboundCommStatusesText = {
  [OutboundCommStatuses.Failed]: "Unsuccessful",
  [OutboundCommStatuses.Sent]: "Sent",
  [OutboundCommStatuses.Pending]: "Sent / pending delivery",
  [OutboundCommStatuses.Delivered]: "Delivered",
  [OutboundCommStatuses.NotSent]: "Unsuccessful",
  [OutboundCommStatuses.NoResponse]: "Unsuccessful",
  [OutboundCommStatuses.Declined]: "Unsuccessful",
  [OutboundCommStatuses.NoLongerRequired]: "Unsuccessful"
};

export const outboundCommReasonText = {
  [OutboundCommType.ApptReminder]: "Appointment reminder",
  [OutboundCommType.Invoice]: "Invoice",
  [OutboundCommType.FormNotify]: "Form",
  [OutboundCommType.ApptCancel]: "Appointment cancellation",
  [OutboundCommType.ApptConfirmation]: "Appointment confirmation",
  [OutboundCommType.ApptFree]: "Appointment free",
  [OutboundCommType.ApptReschedule]: "Appointment reschedule",
  [OutboundCommType.Receipt]: "Receipt",
  [OutboundCommType.Statement]: "Statement",
  [OutboundCommType.ClinicalReminder]: "Clinical reminder",
  [OutboundCommType.AdminReminder]: "Admin reminder",
  [OutboundCommType.Claim]: "Claim",
  [OutboundCommType.ClaimAdjustment]: "Claim adjustment",
  [OutboundCommType.Correspondence]: "Correspondence",
  [OutboundCommType.ExportPatientRecord]: "Export patient record",
  [OutboundCommType.PhysitrackApiKey]: "Physitrack API key"
};
